import React, { useEffect, useState } from "react";
import DescriptionAmenities from "../../components/UserSideComponents/Home/DescriptionAmenities";
// import WhyChooseUs from '../../components/UserSideComponents/Home/WhyChooseUs';
// import Work from '../../components/UserSideComponents/Home/Work';
import Hero from "../../components/UserSideComponents/Home/Hero";
import Alwayshave from "../../components/UserSideComponents/Home/Alwayshave";
import Feedback from "../../components/UserSideComponents/Home/Feedback";
import TouchWithUs from "../../components/UserSideComponents/Home/TouchWithUs";
import States_with_obstacles from "../../components/UserSideComponents/Home/States_with_obstacles";
import PopuUpModal from "../../components/common/PopuUpModal";
const Home = () => {
  const [showPopUp, setShowPopUp] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopUp(true);
    }, 3000); // 2 seconds delay

    return () => clearTimeout(timer); // cleanup
  }, []);
  return (
    <div className="overflow-x-hidden overflow-y-hidden">
      {showPopUp && <PopuUpModal onClose={() => setShowPopUp(false)} />}
      <Hero />
      <States_with_obstacles />
      <DescriptionAmenities />
      {/* <WhyChooseUs/> */}
      {/* <Work/> */}
      <Alwayshave />
      <Feedback />
      <TouchWithUs />
    </div>
  );
};

export default Home;
